const normalizeSpaces = (value = "") => value.replace(/\s+/g, " ").trim();

export const normalizeFranchiseName = (name = "") => {
  const normalizedName = normalizeSpaces(String(name || ""));
  if (!normalizedName) {
    return "";
  }

  const withoutTeamWord = normalizeSpaces(
    normalizedName.replace(/\bteam\b/gi, "")
  );

  return withoutTeamWord || normalizedName;
};

export const getFranchiseRepresentativeNames = (franchise = {}) => {
  const owners = Array.isArray(franchise?.digital_franchise_owners)
    ? franchise.digital_franchise_owners
    : [];

  const names = owners
    .map((owner) => owner?.appify_consultant?.name || owner?.name || "")
    .map((name) => normalizeSpaces(String(name || "")))
    .filter((name) => !!name);

  return Array.from(new Set(names)).join(" / ");
};

export const formatFranchiseNameWithRepresentative = (
  franchiseName = "",
  representativeName = ""
) => {
  const normalizedName = normalizeFranchiseName(franchiseName);
  const normalizedRepresentative = normalizeSpaces(
    String(representativeName || "")
  );

  if (!normalizedName) {
    return normalizedRepresentative;
  }

  if (!normalizedRepresentative) {
    return normalizedName;
  }

  return `${normalizedName} - ${normalizedRepresentative}`;
};

export const getDigitalFranchiseDisplayName = (franchise = {}) => {
  if (franchise?.display_name) {
    return normalizeSpaces(String(franchise.display_name));
  }

  const normalizedName = normalizeFranchiseName(franchise?.name || "");
  const representativeNames = getFranchiseRepresentativeNames(franchise);

  return formatFranchiseNameWithRepresentative(
    normalizedName,
    representativeNames
  );
};
